import moment from "moment";
import React, { Component } from "react";
import { connect } from "react-redux";
import ReactTable from "react-table";
import { listAdminUsers } from "../../action/registerAction";
import PatientIntakeDetails from "../account/PatientIntakeDetails";
import AddText from "./AddText";
import "./SirenNotes.css";
import UpdateNote from "./UpdateNote";

class Notes extends Component {

  componentDidMount() {
    if (this.props.listAdminStaff.length === 0) {
      this.props.listAdminUsers();
    }
  }

  getAuthorName(author) {
    if (!author) {
      return "";
    }
    if (author.startsWith("Siren-")) {
      author = author.substring(6);
    } else if (author.startsWith("Siren -")) {
      author = author.substring(7);
    }

    let [doctor] = this.props.listStaff.filter(item => item.email === author);
    if (doctor) {
      if (doctor.isPrescribing && !doctor.firstName.includes("Dr.")) {
        return `Dr. ${doctor.firstName || ""} ${doctor.lastName || ""}`;
      }
      return `${doctor.firstName} ${doctor.lastName}`;
    }
    let [adminStaff] = this.props.listAdminStaff.filter(item => item.id === author);
    if (adminStaff) {
      return `${adminStaff.firstName} ${adminStaff.lastName}`;
    }

    return author;
  }

  render() {
    const columns = [
      {
        Header: "DATE",
        headerStyle: { display: "flex", alignItems: "center" },
        accessor: "timestamp",
        width: 130,
        Cell: props => {
          return moment(props.original.timestamp).format("YYYY-MM-DD")
        }
      },
      {
        Header: "AUTHOR",
        accessor: "fmtAuthor",
        width: 150,
        style: {textAlign: "left"},
      },
      {
        Header: "NOTE",
        accessor: "title",
        style: {textAlign: "left"},
        filterMethod: (filter, row) => {
          let searchText = `${row.title || ""} ${row._original.note || ""}`;
          return searchText.toLowerCase().includes(filter.value.toLowerCase());
        },
        Cell: props => {
          if (props.row.title === "Patient Intake Details") {
            return (
              <PatientIntakeDetails
                userInfo={this.props.doctorDetails}
                title={props.original.title}
                note={props.original.note}
                timestamp={props.original.timestamp}
              />
            );
          } else {
            return (
              <UpdateNote
                patientNote={props.original}
              />
            );
          }
        }
      }
    ];
    let data = this.props.initializedNote;
    if (this.props.doctorDetails && this.props.doctorDetails.notes) {
      data = data.concat(this.props.doctorDetails.notes);
    }
    data = data.sort(function(a, b) {
      if (a.pinned === 'Yes') {
        return -1;
      }
      if (b.pinned === 'Yes') {
        return 1;
      }
      return b.timestamp.localeCompare(a.timestamp);
    });
    // pin 'Special Case: Yes'
    for (let i = 0; i < data.length; i++) {
      const element = data[i];
      if (element.title === 'Special Case: No') {
        break;
      } else if (element.title === 'Special Case: Yes') {
        if (i !== 0) {
          data.splice(i, 1)
          data.splice(0, 0, element)
        }
        break;
      }
    }

    return (
      <div className="notes_box">
        <div className="note_title_box">
          <div className="note_title">PATIENT NOTES</div>
          <div className="note_add_button">
            <AddText />
          </div>
          <div className="clear_both" />
        </div>
        <div className="patientContent">
          <ReactTable
            style={{ width: "100%" }}
            filterable={true}
            defaultFilterMethod={(filter, row) => {
              return row[filter.id]
                .toLowerCase()
                .includes(filter.value.toLowerCase());
            }}
            data={data}
            resolveData={data =>
              data.map(d => {
                let fmtData = { ...d };
                fmtData.fmtAuthor = this.getAuthorName(d.author);
                return fmtData;
              })
            }
            columns={columns}
            showPagination={false}
            minRows={0}
          />
        </div>
      </div>
    );
  }
}
const mapStateToProp = state => ({
  doctorDetails: state.patientsListStore.doctorDetails,
  initializedNote: state.patientsListStore.initializedNote,
  listStaff: state.patientsListStore.listStaff,
  listAdminStaff: state.patientsListStore.listAdminStaff
});

const mapDispatchToProp = dispatch => ({
  listAdminUsers: () => dispatch(listAdminUsers())
});
export default connect(mapStateToProp, mapDispatchToProp)(Notes);
